import { Routes, Route } from 'react-router-dom';
import QRValidarPage from './pages/QRValidarPage';

function App() {
  return (
    <Routes>
      <Route path="/qrvalidar/:personaId/:hapId" element={<QRValidarPage />} />
      <Route path="/qrvalidar/:tipo/:personaId/:hapId" element={<QRValidarPage />} />
      <Route path="*" element={<h1 className="text-center mt-5">404 - Página no encontrada</h1>} />
    </Routes>
  );
}

export default App;